module.exports = __webpack_public_path__ + "static/media/mp.a2740b82.svg";